import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useHistory, useParams} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import IconButton from '@mui/material/IconButton';

import PrimaryAppBar from './PrimaryAppBar';
import SecondaryAppBar from './SecondayAppBar';
import StudentForm from './StudentForm';
import StudentMenu from './StudentMenu';
import {fetchStudent, selectStudents} from '../../redux/slices/builder';
import {faEllipsisV} from '@fortawesome/pro-regular-svg-icons';

export default function Student() {
  const dispatch = useDispatch();
  const history = useHistory();

  const [isLessonMenuOpen, toggleLessonMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const {studentID} = useParams();
  const students = useSelector(selectStudents);
  const student = students.find((student) => student.id === studentID);

  useEffect(() => {
    if (studentID && !student) {
      dispatch(fetchStudent(studentID));
    }
  }, [dispatch, studentID, student]);

  function handleClickLessonMenu(event) {
    setAnchorEl(event.currentTarget);
    toggleLessonMenu(true);
  }

  function formatHeaderTitle() {
    return student ? `${student.lastName}, ${student.firstName}` : 'Add Student';
  }

  function handleClickCancel() {
    history.push('/builder/students');
  }

  function postSave() {
    history.push({
      pathname: '/builder/students',
      state: {isSaved: true}, // Used to show snackbar
    });
  }

  return (
    <>
      <StudentMenu anchorEl={anchorEl} isMenuOpen={isLessonMenuOpen} toggleMenu={toggleLessonMenu} student={student} />
      <PrimaryAppBar />
      <SecondaryAppBar title={formatHeaderTitle()} backURL="/builder/students">
        <IconButton
          onClick={handleClickLessonMenu}
          size="large"
          className="bg-brandorange m-l-15"
          sx={{width: 45, height: 45, '&:hover': {backgroundColor: 'rgba(238, 65, 39, 0.8)'}}}
        >
          <FontAwesomeIcon icon={faEllipsisV} size="xs" className="clr-gray-200" />
        </IconButton>
      </SecondaryAppBar>

      <StudentForm student={student} postSave={postSave} onCancel={handleClickCancel} />
    </>
  );
}
